import classNames from "classnames";
import React from "react";
import * as tlTheme from "../../../theme/exports.scss";
import "./bulma.scss";

export class Bulma extends React.Component {
  public render() {
    return (
      <div className="bulma-guide">
        <h1>Bulma Guide</h1>
        <div className="columns">
          <div className={classNames("column", "is-8", "is-offset-2")}>
            <p>Amidst the rebrand work, we are implementing a 12 column grid system across the site. Bulma is the dominant choice at the current time in the CSS framework world
             and suits our needs perfectly. Bulma is simply a modular css import, so we can import the grid system to our current CSS structure and gradually implement it across
              the site with minimal changes.</p>
          </div>
        </div>
        <h1>12 column grid system</h1>
        <div className="columns">
          <div className="column"><p className="fill">1</p></div>
          <div className="column"><p className="fill">2</p></div>
          <div className="column"><p className="fill">3</p></div>
          <div className="column"><p className="fill">4</p></div>
          <div className="column"><p className="fill">5</p></div>
          <div className="column"><p className="fill">6</p></div>
          <div className="column"><p className="fill">7</p></div>
          <div className="column"><p className="fill">8</p></div>
          <div className="column"><p className="fill">9</p></div>
          <div className="column"><p className="fill">10</p></div>
          <div className="column"><p className="fill">11</p></div>
          <div className="column"><p className="fill">12</p></div>
        </div>
        <div className={classNames("column", "is-10", "is-offset-1")}>
          <p>This is what a 12 column grid looks like. If you take a look at this source file you will see that this is simply achieved by having a parent div with a class
             of <span>columns</span> and 12 children with a class of <span>column</span>. This is the basis of our grid system. Notice here how if you shrink the window, the
              columns become full width on mobile, but not on tablet.</p>
        </div>
        <h1>Sizing elements in the grid</h1>
        <div className={classNames("column", "is-10", "is-offset-1")}>
          <p>The elements which we are building should be dividable by 12 to fit within the grid system. 12 being full width and 1 being a twelth of the its container.
           Once we know the size of an element, it is as simple as giving it a className of <span>is-6</span> or <span>is-3</span> depending on its division. If we have a design
            where one element has been sized but the rest are meant to fill the remaining space, we only need to apply the <span>is-x</span> class to that one element and so
             long as the rest have the <span>column</span> class, they will fill the remaining space equally.</p>
        </div>
        <div className="columns">
          <div className={classNames("column", "is-3")}><p className="fill">is-3</p></div>
          <div className="column"><p className="fill">4</p></div>
          <div className="column"><p className="fill">5</p></div>
          <div className="column"><p className="fill">6</p></div>
          <div className={classNames("column", "is-6")}><p className="fill">is-6</p></div>
        </div>
        <div className="columns">
          <div className="column"><p className="fill">1</p></div>
          <div className="column"><p className="fill">2</p></div>
          <div className="column"><p className="fill">3</p></div>
          <div className={classNames("column", "is-9")}><p className="fill">is-9</p></div>
        </div>
        <h1>What about whitespace?</h1>
        <div className={classNames("column", "is-10", "is-offset-1")}>
          <p>Sometimes we do not want elements covering the entire width of the design but to be surrounded with whitespace. We could achieve this effect with the methods above,
             but it requires a lot of unneccessary divs to create the right column spacing. We can create the same effect by using <span>is-offset-x</span>, which when applied to
              an element will offset its placement from the left by the number of columns given. This is the cleanest method possible and I suggest this to be the best practice
               across our codebase. We can re-create the above design like so:</p>
        </div>
        <div className="columns">
          <div className={classNames("column", "is-3")}><p className="fill">is-3</p></div>
          <div className={classNames("column", "is-6", "is-offset-3")}><p className="fill">is-6, is-offset-3</p></div>
        </div>
        <div className="columns">
          <div className={classNames("column", "is-9", "is-offset-3")}><p className="fill">is-9, is-offset-3</p></div>
        </div>
        <h1>Nesting</h1>
        <div className={classNames("column", "is-10", "is-offset-1")}>
          <p>It is possible to nest columns so that content which should be grouped together, stays together. To achieve this, follow this structure:</p>
          <ul className="nesting-structure">
            <li><span>columns</span> : top-level columns container</li>
            <ul>
              <li><span>column</span></li>
              <ul>
                <li><span>columns</span> : nested columns</li>
                <ul>
                  <li><span>column</span> and so on...</li>
                </ul>
              </ul>
            </ul>
          </ul>
          <br></br>
          <p>Notice how at the mobile viewport, the content groups together.</p>
          <p>Additionally take note of how each <span>columns</span> container has its own 12 grid system, <span>is-6</span> here is half of its container,
           not half of the page.</p>
        </div>
        <div className="columns">
          <div className="column">
            <div className="columns">
              <div className="column"><p className="fill">Auto</p>
                <div className="columns">
                  <div className="column"><p className="fill">Auto</p></div>
                  <div className="column"><p className="fill">Auto</p></div>
                </div>
              </div>
            </div>
          </div>
          <div className="column">
            <div className="columns">
              <div className="column"><p className="fill secondary">Auto</p>
                <div className="columns">
                  <div className={classNames("column", "is-6")}><p className="fill secondary">is-6</p></div>
                  <div className="column"><p className="fill secondary">Auto</p></div>
                  <div className="column"><p className="fill secondary">Auto</p></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h1>Situational stylings</h1>
        <div className={classNames("column", "is-10", "is-offset-1")}>
          <p>The methods above should be considered the basis of implementing the grid system and the majority of the time, for simplicity and code-tidyness, this should be all
             that we need to use. However there will be situations where this basis is not enough and therefore, the below methods can be used for more custom sizing.</p>
        </div>
        <h1>Different column sizes per breakpoint</h1>
        <div className={classNames("column", "is-10", "is-offset-1")}>
          <p>It is rather simple to apply a different column size per viewport if the design requires it. This is achieved by chaining the viewport after the size:<br></br>
            <span>is-3-desktop</span>, <span>is-6-tablet</span>, or <span>is-9-mobile</span>. It is worth noting that sizes without breakpoint modifiers should not be used
             with custom sizes, as they will override the custom sizes. Remember that if you are wanting to use a custom mobile size, the parent element will need the
              <span>is-mobile</span> className, otherwise it will default to stacking. Notice how the columns change size below dependant on the viewport.</p>
        </div>
        <div className="columns is-mobile">
          <div className={classNames("column", "is-3-desktop", "is-6-tablet", "is-9-mobile")}><p className="fill">is-3-desktop, is-6-tablet, is-9-mobile</p></div>
          <div className="column"><p className="fill">Auto</p></div>
        </div>
        <h1>Columns on mobile</h1>
        <div className={classNames("column", "is-10", "is-offset-1")}>
          <p>By default, columns are only activated from tablet upwards. This means columns are stacked on top of each other on mobile. If you want columns to work on mobile too,
             just add the <span>is-mobile</span> className on the <span>columns</span> container. Notice how if you shrink the window now, the bottom columns will stay present on
              mobile.</p>
        </div>
        <div className="columns">
          <div className={classNames("column", "is-3")}><p className="fill">is-3</p></div>
          <div className={classNames("column", "is-6", "is-offset-3")}><p className="fill">is-6, is-offset-3</p></div>
        </div>
        <div className="columns is-mobile">
          <div className={classNames("column", "is-9", "is-offset-3")}><p className="fill">is-9, is-offset-3</p></div>
        </div>
        <h1>Columns on desktop only</h1>
        <div className={classNames("column", "is-10", "is-offset-1")}>
          <p>By default, columns become full width at the mobile breakpoint. If you want this to be true for tablet also, add the <span>is-desktop</span> className to the
           <span>columns</span> container, meaning that columns will only be present on desktop. Additionally if you have columns which have sizing classNames,
            <span>is-offset-3</span> or <span>is-6</span> for example, these will also need <span>-desktop</span> chained to them, as we only want these sizes applied at a desktop
             viewport. Notice how if you shrink the viewport now, the top columns become full width on tablet and mobile.</p>
        </div>
        <div className="columns is-desktop">
          <div className={classNames("column", "is-3-desktop")}><p className="fill">is-3-desktop</p></div>
          <div className={classNames("column", "is-6-desktop", "is-offset-3-desktop")}><p className="fill">is-6-desktop, is-offset-3-desktop</p></div>
        </div>
        <div className="columns">
          <div className={classNames("column", "is-9", "is-offset-3")}><p className="fill">is-9, is-offset-3</p></div>
        </div>
        <h1>Breakpoints</h1>
        <div className={classNames("column", "is-10", "is-offset-1")}>
          <p>These are the screen widths that the above classes work with:</p>
          <div className="columns">
            <div className="column is-2 fill">
              <h3>tablet</h3>
              <strong>{tlTheme.tabletWidth}</strong>
            </div>
            <div className="column is-2 is-offset-1 fill">
              <h3>desktop</h3>
              <strong>{tlTheme.desktopWidth}</strong>
            </div>
            <div className="column is-2 is-offset-2 fill">
              <h3>widescreen</h3>
              <strong>{tlTheme.widescreenWidth}</strong>
            </div>
            <div className="column is-2 is-offset-1 fill">
              <h3>fullhd</h3>
              <strong>{tlTheme.fullhdWidth}</strong>
            </div>
          </div>
        </div>
        <h1>I need more!</h1>
        <div className={classNames("column", "is-10", "is-offset-1")}>
          <p>That's great! You can head over to the Bulma docs <a href="https://bulma.io/documentation/columns/basics/" target="_blank">here</a>. If you find anything that you
           feel would be a good method for the implementation of our designs that isn't present here, please do let me know. Or if you are having some trouble with using this
            guide or Bulma, just give me a shout. Thanks for reading. Lloyd.</p>
        </div>
      </div>
    );
  }
}
